import React from 'react';

import { useAtom } from 'jotai';

import {
  useBlocAccountSummary,
} from '@consumer-frontend/api';
import {
  ListGroup,
  ListGroupItem,
  Nav,
} from '@consumer-frontend/shared-ui';

import { BlocNavSelection } from './BlocNavSelection';
import { accountIdAtom } from '../../store';
import { Error } from '../Error';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/nav.scss';

type BlocNavPropsT = {
  responsiveFlexClass: 'd-flex' | 'd-md-flex';
  displayNone?: boolean;
  hasBoxShadow?: boolean;
};

export type BlocNavT = React.FC<BlocNavPropsT>;

export const BlocNav: BlocNavT = ({
  displayNone,
  responsiveFlexClass,
  hasBoxShadow,
}) => {
  const navClasses = [
    displayNone ? 'd-none' : '',
    responsiveFlexClass,
    'container',
    'flex-column',
    'justify-content-between',
    hasBoxShadow ? 'shadow-sm' : 'shadow-none',
    'rounded',
    'cnu-nav',
  ].join(' ');

  const [accountId] = useAtom(accountIdAtom);

  const {
    blocAccountSummary,
    error,
    isLoading,
  } = useBlocAccountSummary(accountId);

  return (
    <Nav className={navClasses} id="bloc-nav" navbarScroll>
      <ListGroup className="list-group" variant="flush">
        {isLoading && 'Loading...'}
        {error && <Error message={error.message} />}
        {blocAccountSummary && (
          <ListGroupItem className="list-group-item pb-5">
            <h3 className="mb-1">Hello, {`${blocAccountSummary.first_name}`}</h3>
            <strong>Account # {blocAccountSummary.account_id}</strong>
          </ListGroupItem>
        )}
        <BlocNavSelection accountInfo={blocAccountSummary} />
      </ListGroup>
    </Nav>
  );
};
